import React, { useContext, useState } from "react";
import {
	BusinessDataContext,
	BusinessDataContextValues,
	LoginContext,
	LoginContextValues,
	MultistepContext,
	MultistepContextValues,
} from "../../types/context";
import { Alert, Snackbar, Stack, Typography } from "@mui/material";
import { findActiveComponent } from "../../utils/filter";
import { HeaderStepper } from "./HeaderStepper";
import { Home } from "../home/Home";
import FindTable from "../steps/findTable/FindTable";
import { ChooseService } from "../steps/chooseService/ChooseService";
import Details from "../steps/details/Details";
import Login from "../steps/login/EmailLogin";
import Register from "../steps/login/Register";
import RecoverPassword from "../steps/login/RecoverPassword";
import ChangePassword from "../steps/login/ChangePassword";
import Profile from "../steps/profile/Profile";
import { FormattedMessage } from "react-intl";

// The RenderStepContent component evaluates the active step and renders the
// corresponding component to that step according to the Flow the user has chosen.
export const RenderStepContent = ({ setHeaderTitle }) => {
	const { activeStep } = useContext(MultistepContext) as MultistepContextValues;
	const { selectedFlow } = useContext(
		BusinessDataContext
	) as BusinessDataContextValues;
	const { isCalledFromProfile } = useContext(
		LoginContext
	) as LoginContextValues;

	const [success, setSuccess] = useState("");
	const [error, setError] = useState("");

	//Getting the active component name
	const activeComponent = findActiveComponent(selectedFlow!, activeStep);
	const showStepper = !(activeComponent === "Login" && isCalledFromProfile);

	//Mapping the component according to the name
	const componentMap = {
		Profile: <Profile setSuccess={setSuccess} />,
		ChangePassword: <ChangePassword setSuccess={setSuccess} />,
		RecoverPassword: (
			<RecoverPassword
				setHeaderTitle={setHeaderTitle}
				setSuccess={setSuccess}
				setGoogleError={setError}
			/>
		),
		Register: (
			<Register setHeaderTitle={setHeaderTitle} setSuccess={setSuccess} setGoogleError={setError} />
		),
		LoginFromProfile: <Login setGoogleError={setError} />,
		Home: <Home />,
		FindTable: <FindTable />,
		ChooseService: <ChooseService />,
		Login: <Login setGoogleError={setError} />,
		Details: <Details setSuccess={setSuccess} />,
	};

	return (
		<Stack alignItems="center" sx={{ width: "100%", marginTop: 3 }} spacing={3}>
			{activeStep > 0 && showStepper && <HeaderStepper />}
			{componentMap[activeComponent]}
			{activeStep === 1 && (
				<Typography sx={{ fontWeight: "400" }} alignSelf="flex-start">
					<FormattedMessage
						id="findTable.message"
						defaultMessage="Su reserva será hecha de manera segura e instantánea."
					/>
				</Typography>
			)}
			<Snackbar
				open={!!success}
				onClose={() => setSuccess("")}
				autoHideDuration={4000}
				anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
			>
				<Alert
					onClose={() => setSuccess("")}
					severity="success"
					variant="filled"
					sx={{ width: "100%", fontWeight: 300 }}
				>
					{success}
				</Alert>
			</Snackbar>
			<Snackbar
				open={!!error}
				onClose={() => setError("")}
				autoHideDuration={4000}
				anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
			>
				<Alert
					onClose={() => setError("")}
					severity="error"
					variant="filled"
					sx={{ width: "80%", fontWeight: 300 }}
				>
					{error}
				</Alert>
			</Snackbar>
		</Stack>
	);
};
